@import (reference) '../../../../../../constants/spacing.module.less';

.icon {
  height: 12px;
  width: 12px;
  margin-left: @space-8;
}

.button {
  white-space: nowrap;
}
